export const namespaces = {
  INVESTOR_LOGIN: 'investor_login',
  INVESTOR_LOGIN_FORM: 'investor_login_form',
  INVESTOR_COMPLETE_PROFILE: 'investor_complete_profile',
  TERMS_OF_USE: 'terms_of_use',
};
